export default __webpack_public_path__ + "static/media/dreamland.10071b84.gif";